import { useMemo } from 'react'
import { useHazardGroupBuckets } from '@app/modules/Risk/Profile/hooks/useHazardGroupBuckets'
import { buildRiskProfileSocialEconomicRequest } from '../utils/buildRiskProfileSocialEconomicRequest'
import {
  useRiskProfilePropertiesElementConfig,
  type RiskProfilePropertiesDomain,
} from './useRiskProfilePropertiesElementConfig'
import type {
  ProfilePropertiesRequest,
  ProfilePropertiesWidgetKey,
  useRiskProfileSocialEconomicRequestOptions,
} from '../types/riskProfileProperties.types'

function widgetDomain(widget: ProfilePropertiesWidgetKey): RiskProfilePropertiesDomain {
  return widget.startsWith('residents') ? 'social' : 'economic'
}

export function useRiskProfileSocialEconomicRequest({
  queryParams,
  widget,
}: useRiskProfileSocialEconomicRequestOptions): ProfilePropertiesRequest | null {
  const hazardGroupBuckets = useHazardGroupBuckets(queryParams?.hazards ?? [])
  const elementConfig = useRiskProfilePropertiesElementConfig(widgetDomain(widget))

  return useMemo(() => {
    if (queryParams === null || elementConfig === null) {
      return null
    }

    return buildRiskProfileSocialEconomicRequest({
      queryParams,
      widget,
      hazardGroupBuckets,
      elementConfig,
    })
  }, [elementConfig, hazardGroupBuckets, queryParams, widget])
}
